export default __webpack_public_path__ + "static/media/logo.f338e06d.png";